import { IconProps } from '../types';

function ArrowRightTriangleSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      className={className || 'h-6 w-6'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fillRule="evenodd" d="M14 10 L8 4 L8 16 Z" />
    </svg>
  );
}

export default ArrowRightTriangleSolidIcon;
